// extracted by mini-css-extract-plugin
export default {"navItem":"NavItem_navItem__49wRB","active":"NavItem_active__b3Vot","label":"NavItem_label__EaIVC"};